import * as types from '../constants/actiontypes';

const initialState = {
	brands: [],
};

const Brands = (state = initialState, action) => {
	switch (action.type) {
		case types.RECEIVE_BRANDS:
			return { ...state, brands: action.data };

		default:
			return state;
	}
};
export default Brands;
